import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import useClientContext from "../../../contexts/useClientContext";
import { identityAvatarImageSelector } from "../../../store/state/user/selectors";

const UserComponent = () => {
  const { contactName, contactEmail } = useClientContext();

  const avatarImage = useSelector(identityAvatarImageSelector);

  return (
    <Stack direction="row" spacing={1} sx={{ width: "100%", alignItems: "center" }}>
      <UserAvatar size="large" userName={contactName} avatarImage={avatarImage} />
      <Stack sx={{ minWidth: 0 }}>
        <Typography noWrap variant="subtitle2" color="textPrimary">
          {contactName}
        </Typography>
        {contactEmail && (
          <Typography variant="caption" noWrap color="textSecondary">
            {contactEmail}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default UserComponent;
